import React from "react";
import { observer } from "mobx-react";

// Translations
import translate from "../Translate.js";
import {
  checkValidity,
  closeDrawer
} from "../../helpers/helpers.js";

const CreateUser = observer(
  class CreateUser extends React.Component {
    constructor() {
      super();

      this.state = {
        firstName: null,
        lastName: null,
        email: null,
        username: null,
      };
    }

    /**
     * Submit the settings form.
     *
     * @function handleSubmit
     */
    handleSubmit = () => {
      const { EnrollmentStore, SessionStore } = this.props.store;
      const { firstName, lastName, email, password } = this.state;

      const data = {
        firstName,
        lastName,
        email,
        // Set username to the email the user inputs
        username: this.state.email,
        password
      };

      const callback = () => {
        closeDrawer(null, this.props.parent, "/users");
        SessionStore.showToaster(this.props.translation.userCreated, "success");
      };

      EnrollmentStore.newProctorUser(data, callback);
    };

    /**
     * Store input values.
     *
     * @function handleInput
     * @param {event} e
     */
    handleInput = (e) => {
      const { name, value } = e.target;
      this.setState({
        [name]: value,
      });
    };

    render() {
      const { translation } = this.props;

        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>

            <div className="wrap">
              <form className="form panel panel__body" onSubmit={(e) => checkValidity(e, this.handleSubmit)}>
                <fieldset>
                  <ul className="fields">
                    <li className="field--half">
                      <label
                        className="form__lbl required"
                        htmlFor="user-first-name"
                      >
                        {translation.firstName}
                      </label>

                      <input
                        type="text"
                        id="fuser-first-name"
                        name="firstName"
                        required
                        aria-required="true"
                        data-errormsg="Error message with instructions to correct"
                        onChange={this.handleInput}
                      />
                    </li>
                    <li className="field--half">
                      <label
                        className="form__lbl required"
                        htmlFor="user-last-name"
                      >
                        {translation.lastName}
                      </label>

                      <input
                        type="text"
                        id="user-last-name"
                        name="lastName"
                        required
                        aria-required="true"
                        data-errormsg="Error message with instructions to correct"
                        onChange={this.handleInput}
                      />
                    </li>
                    <li className="field--half">
                      <label className="form__lbl required" htmlFor="user-email">
                          {translation.email}
                        </label>

                        <input
                          type="text"
                          id="user-email"
                          name="email"
                          onChange={this.handleInput}
                        />
                    </li>
                    <li className="field--half">
                      <label className="form__lbl required" htmlFor="user-password">
                          {translation.password}
                        </label>

                        <input
                          type="text"
                          id="user-password"
                          name="password"
                          onChange={this.handleInput}
                        />
                    </li>
                  </ul>
                </fieldset>

                <div className="panel__actions">
                  <button className="btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
);

export default translate("CreateUser")(CreateUser);



// WEBPACK FOOTER //
// ./src/app/components/Users/CreateUser.js